import * as tslib_1 from "tslib";
import React, { useContext } from 'react';
import { MobileContext } from '../Context';
import { FirstTimeFlag, } from '../redux/firstTimeFlags';
import VerificationPopupDesktop from './VerificationPopupDesktop';
import VerificationPopupMobile from './VerificationPopupMobile';
export var VerificationPopup = function (_a) {
    var dropFlagOnClose = _a.dropFlagOnClose, dropFirstTimeFlag = _a.dropFirstTimeFlag, onClose = _a.onClose, props = tslib_1.__rest(_a, ["dropFlagOnClose", "dropFirstTimeFlag", "onClose"]);
    var isMobile = useContext(MobileContext);
    var handleClose = dropFlagOnClose
        ? function () {
            return dropFirstTimeFlag({
                flag: FirstTimeFlag.WelcomePopupNotClosed,
            });
        }
        : onClose;
    if (isMobile) {
        return React.createElement(VerificationPopupMobile, tslib_1.__assign({ onClose: handleClose }, props));
    }
    return React.createElement(VerificationPopupDesktop, tslib_1.__assign({ onClose: handleClose }, props));
};
VerificationPopup.displayName = 'VerificationPopup';
export default VerificationPopup;
//# sourceMappingURL=VerificationPopup.js.map